import { createReducer } from 'redux-create-reducer'
import {CHANGE_POPUP_CACHE} from '../constants'

export const CHANGE_POPUP = 'CHANGE_MODAL';

const initialState = {
  currentPopup: null,
  data: null,
  cache: {},
}

const popup = createReducer(initialState, {
  [CHANGE_POPUP]: (state, action) => ({ ...state, ...action.state }),
  [CHANGE_POPUP_CACHE]: (state, {key, value}) => ({
    ...state,
    cache: {
      ...state.cache,
      [key]: value,
    }
  })
})

export default popup
